import { requests } from './baseServices'

export const UtilsServices = {    
    getTVAs: () => requests.get('api/utils/vat'),
    getExpenseTVAs: () => requests.get('api/utils/expense-vat'),
    getCurrencies: () => requests.get('api/utils/currency'),
    getCountryCurrencies: (params) => requests.get('api/utils/country-currency',params),
    getTemplates: () => requests.get('api/utils/template'),
    getTemplatesWithoutEventType: () => requests.get('api/utils/templates-without-event-type'),
    getClients: () => requests.get('api/utils/client'),
    getProjects: (clientId) => requests.get(`api/utils/project/${clientId}`),
    getProjectsForValidator: (validatorId) => requests.get(`api/utils/project/validator/${validatorId}`),
    getCostsExpenses: (params) => requests.get(`api/utils/costs-expenses/`, params),    
    getExchangeRate: (year, month,from,to) => requests.get(`api/utils/exchange/${year}/${month}/${from}/${to}`),
    getDevelopers: (projectId, includeDeleted) => requests.get(`api/utils/developer/${projectId}/${includeDeleted}`),
    getMonthsForDev: (projectId, devId) => requests.get(`api/utils/months/${projectId}/${devId}`),
    updateEmailServer: (dto) => requests.put(`api/utils/email-server`, dto),
    getEmailServer: () => requests.get(`api/utils/email-server`),
};